'use client';

import * as Styled from './error-screen.styled';
import goatChomp from 'public/animations/goatChomp.json';

import dynamic from 'next/dynamic';
import * as React from 'react';

const Lottie = dynamic(
  () => import('lottie-react').then((mod) => mod.default),
  { ssr: false },
);

export interface ErrorScreenProps {
  'headline': string | number;
  'title': string | React.ReactNode;
  'children'?: React.ReactNode;
  'data-testid'?: string;
}

type Props = Readonly<ErrorScreenProps>;

const ErrorScreen: React.FC<Props> = ({
  headline,
  title,
  children,
  'data-testid': dataTestId,
}) => (
  <Styled.Root data-testid={dataTestId}>
    <Styled.GoatPen>
      <Styled.GoatFood>{headline}</Styled.GoatFood>
      <Styled.AnimationContainer>
        <Lottie
          animationData={goatChomp}
          loop
        />
      </Styled.AnimationContainer>
    </Styled.GoatPen>

    <h3>{title}</h3>

    {children && <p>{children}</p>}
  </Styled.Root>
);

export { ErrorScreen };
